import { BigNumber } from 'bignumber.js';

import SEOClient from '@/services/clients/seo-client';

export default {
  namespaced: true,
  state: {
    isGuestUser: true,
    isPriceUpdateInProgress: false,
    wsConnected: false,
    price: null,
    realtimePrice: null,
    selectedMarket: null,
    selectedFiatCurrency: null,
    selectedCryptoCurrency: null,
    selectedAmount: null,
    availableCryptoCurrencies: [],
    availableFiatCurrencies: [],
    isSelectedAmountCrypto: true,
    usdAggregatePrice: null,
    recentConversions: [],
    heading: null,
    breadcrumbs: [],
    isPublicPage: true,
    isCorporateAccount: false,
    defaultBuyLink: null,
  },
  getters: {
    getAvailableCryptoCurrencyByCode: (state) => (cryptoCode) => {
      return state.availableCryptoCurrencies.find((crypto) => {
        return crypto.code === cryptoCode;
      });
    },
  },
  mutations: {
    setAsMemberPage(state) {
      state.isPublicPage = false;
    },
    setHeading (state, heading) {
      state.heading = heading;
    },
    setBreadcrumbs (state, breadcrumbs) {
      state.breadcrumbs = breadcrumbs;
    },
    setRecentConversions (state, recentConversions) {
      state.recentConversions = recentConversions;
    },
    setSelectedAmountFiat (state, amount) {
      state.selectedAmount = new BigNumber(amount);
      state.isSelectedAmountCrypto = false;
    },
    setSelectedAmountCrypto (state, amount) {
      state.selectedAmount = new BigNumber(amount);
      state.isSelectedAmountCrypto = true;
    },
    setIsGuest (state, isGuest) {
      state.isGuestUser = isGuest;
    },
    setAvailableCryptoCurrencies (state, cryptoCurrencies) {
      state.availableCryptoCurrencies = cryptoCurrencies;
    },
    setAvailableFiatCurrencies (state, fiatCurrencies) {
      state.availableFiatCurrencies = fiatCurrencies;
    },
    useRealtimePrice (state) {
      state.price = state.realtimePrice;
    },
    setPriceData (state, { price, market, fiatCurrency, cryptoCurrency }) {
      state.price = new BigNumber(price);
      state.realtimePrice = state.price;
      state.selectedFiatCurrency = fiatCurrency;
      state.selectedCryptoCurrency = cryptoCurrency;
      state.selectedMarket = market;
    },
    setIsPriceUpdateInProgress (state) {
      state.isPriceUpdateInProgress = true;
    },
    updateUsdAggregatedPrice (state, newPrice) {
      state.usdAggregatePrice = new BigNumber(newPrice);
    },
    setMarket (state, payload) {
      state.selectedMarket = payload;
    },
    setFiatCurrency (state, payload) {
      state.selectedFiatCurrency = payload;
    },
    setCryptoCurrency (state, payload) {
      state.selectedCryptoCurrency = payload;
    },
    setAmount (state, selectedAmount) {
      state.selectedAmount = new BigNumber(selectedAmount);
    },
    SOCKET_RECONNECT (state) {
      state.wsConnected = true;
    },
    SOCKET_ONOPEN (state) {
      state.wsConnected = true;
    },
    SOCKET_ONCLOSE (state) {
      state.wsConnected = false;
    },
    SOCKET_ONMESSAGE (state, records) {
      const newPriceData = records[state.selectedCryptoCurrency.code] || false;
      if (!newPriceData) {
        return;
      }
      const newPrice = newPriceData.price || false;
      if (!newPrice) {
        return;
      }
      state.realtimePrice = new BigNumber(newPrice);
    },
    SOCKET_ONERROR (state, event) {
      console.error(event);
    },
    setIsCorporateAccount (state, payload) {
      state.isCorporateAccount = payload;
    },
    setDefaultBuyLink (state, payload) {
      state.defaultBuyLink = payload;
    },
  },
  actions: {
    requestRecentConversions ({ commit }) {
      return SEOClient.getRecentConversions().then((conversions) => {
        commit('setRecentConversions', conversions);
      });
    },

    requestUsdAggregatePrice ({ state, commit }, cryptoCurrency) {
      return SEOClient.getPrice(
        state.selectedMarket.value,
        cryptoCurrency.code,
        state.selectedFiatCurrency.code,
      )
        .then((price) => {
          commit('updateUsdAggregatedPrice', price);
        });
    },

    requestPrice ({ commit }, { market, cryptoCurrency, fiatCurrency }) {
      return SEOClient.getPrice(market.value, cryptoCurrency.code, fiatCurrency.code)
        .then((price) => {
          commit('setPriceData', {
            price,
            market,
            fiatCurrency,
            cryptoCurrency,
          });
        });
    },
    requestAvailableFiats ({ commit }) {
      return SEOClient.getAvailableFiatCurrencies()
        .then((fiats) => {
          commit('setAvailableFiatCurrencies', fiats);
        });
    },
    requestAvailableCryptos ({ commit }) {
      return SEOClient.getAvailableCryptoCurrencies()
        .then((cryptos) => {
          commit('setAvailableCryptoCurrencies', cryptos);
        });
    },
  },
};
